import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaNomeAluno = (): TabelaColuna => ({
  Chave: 'nomeAluno',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Nome</div>
})
